<header class="main-header-two">
    <div class="main-menu-two__top">
        <div class="main-menu-two__top-inner">
            <ul class="list-unstyled main-menu-two__contact-list">
                <li>
                    <div class="icon"> <i class="icon-phone-call"></i> </div>
                    <div class="text">
                        <p><a href="tel:+919447117399">+91 944 7117 399</a></p>
                    </div>
                </li>
                <li>
                    <div class="icon"> <i class="icon-email"></i> </div>
                    <div class="text">
                        <p><a href="mailto:Shingadshippinglines@gmail.com">Shingadshippinglines&#64;gmail.com</a> </p>
                    </div>
                </li>
            </ul>
            <div class="main-menu-two__top-right">
                <div class="main-menu-two__top-time">
                    <div class="main-menu-two__top-time-icon"> <span class="fas fa-clock"></span> </div>
                    <p class="main-menu-two__top-text">Mon - Sat: 09:00 AM - 07:00 PM</p>
                </div>
                <!-- <div class="main-menu-two__social"> <a href="https://x.com/thanvikaentps25"><i
                            class="fab fa-twitter"></i></a> <a href="https://www.facebook.com/thanvika.enterprises25"><i
                            class="fab fa-facebook"></i></a><a href="https://www.instagram.com/thanvika_enterprises_"><i
                            class="fab fa-instagram"></i></a> </div> -->
            </div>
        </div>
    </div>
    <nav class="main-menu">
        <div class="main-menu-two__wrapper">
            <div class="main-menu-two__wrapper-inner">
                <div class="main-menu-two__left">
                    <div class="main-menu-two__logo"> <a href=""><img src="assets/images/resources/logo-2.png" alt=""
                                ></a> </div>
                </div>
                <div class="main-menu-two__main-menu-box"> <a class="mobile-nav__toggler" (click)="toggleMobileMenu()">
                        <i class="fa fa-bars"></i></a>
                    <ul class="main-menu__list">
                        <li> <a routerLink="/">Home</a> </li>
                        <li> <a routerLink="/about">About</a> </li>
                        <li class="dropdown"><a href="#">Services</a>
                            <ul class="shadow-box">
                                <li class="dropdown-submenu"><a routerlink="#" class="submenu-toggle"
                                        ng-reflect-router-link="#" href="/%23"> Exports </a>
                                    <ul class="shadow-box submenu-items">
                                        <li><a routerlink="/spices-products" ng-reflect-router-link="/spices-products"
                                                href="/spices-products">Spices</a> </li>
                                        <li><a routerlink="/forest-products" ng-reflect-router-link="/forest-products"
                                                href="/forest-products">Forest Products</a></li>
                                        <li><a routerlink="/agricultural-products"
                                                ng-reflect-router-link="/agricultural-products"
                                                href="/agricultural-products">Agricultural Products</a></li>
                                        <li><a routerlink="/other-products" ng-reflect-router-link="/other-products"
                                                href="/other-products">Other Products</a></li>
                                    </ul>
                                </li>
                                <li class="dropdown-submenu"><a routerlink="#" class="submenu-toggle"
                                        ng-reflect-router-link="#" href="/%23"> Import </a>
                                    <ul class="shadow-box submenu-items">
                                        <li><a routerlink="/" ng-reflect-router-link="/" href="/">Imports </a> </li>
                                    </ul>
                                </li>
                                <li class="dropdown-submenu"><a routerlink="#" class="submenu-toggle"
                                        ng-reflect-router-link="#" href="/%23"> Shipping &amp; Maritime Operations </a>
                                    <ul class="shadow-box submenu-items">
                                        <li class="dropdown-submenu"><a routerlink="/ship-chandling-division"
                                                class="submenu-toggle" ng-reflect-router-link="/ship-chandling-division"
                                                href="/ship-chandling-division"> Ship Chandling Division </a></li>
                                        <li class="dropdown-submenu"><a routerlink="/crew-change-services"
                                                class="submenu-toggle" ng-reflect-router-link="/crew-change-services"
                                                href="/crew-change-services"> Crew Change Services </a></li>
                                    </ul>
                                </li>
                                <li class="dropdown-submenu"><a routerlink="#" class="submenu-toggle"
                                        ng-reflect-router-link="#" href="/%23"> Port and Hydrography </a>
                                    <ul class="shadow-box submenu-items">
                                        <li><a routerlink="/hydrographic-survey-services"
                                                ng-reflect-router-link="/hydrographic-survey-services"
                                                href="/hydrographic-survey-services">Hydrographic Survey Navigational
                                                Auditing</a> </li>
                                        <li><a routerlink="/marine-works-and-dredging-services"
                                                ng-reflect-router-link="/marine-works-and-dredging-ser"
                                                href="/marine-works-and-dredging-services">Dredging Assistance</a></li>
                                        <li><a routerlink="/pilotage-and-mooring-operations"
                                                ng-reflect-router-link="/pilotage-and-mooring-operatio"
                                                href="/pilotage-and-mooring-operations">Ship Mooring, Tug &amp;
                                                Pilotage</a></li>
                                    </ul>
                                </li>
                                <li class="dropdown-submenu"><a href="#" class="submenu-toggle"> Legal Services </a>
                                    <ul class="shadow-box submenu-items">
                                        <li><a routerlink="/maritime-claims" ng-reflect-router-link="/maritime-claims"
                                                href="/maritime-claims">Maritime (Admiralty) claims</a></li>
                                        <li><a routerlink="/marine-insurance" ng-reflect-router-link="/marine-insurance"
                                                href="/marine-insurance">Marine insurance claims</a></li>
                                        <li><a routerlink="/arbitration-mediation"
                                                ng-reflect-router-link="/arbitration-mediation"
                                                href="/arbitration-mediation">Arbitration &amp; mediation</a></li>
                                        <li><a routerlink="/legal-consultations"
                                                ng-reflect-router-link="/legal-consultations"
                                                href="/legal-consultations">Legal advice &amp; consultations</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                        <li> <a routerLink="/gallery">Gallery</a> </li>
                        <li> <a routerLink="/contact">Contact</a> </li>
                    </ul>
                </div>
                <div class="main-menu-two__right">
                    <div class="main-menu-two__right-content">
                        <div class="main-menu-two__call">
                            <div class="main-menu-two__call-icon"> <i class="icon-phone-call"></i> </div>
                            <div class="main-menu-two__call-content">
                                <p class="main-menu-two__call-sub-title">Call Anytime</p>
                                <h5 class="main-menu-two__call-number"><a href="tel:09447117399">+91 944 7117 399</a>
                                </h5>
                            </div>
                        </div>
                        <div class="main-menu-two__search-cart-box" style="display: none;">
                            <div class="main-menu-two__search-cart-box">
                                <div class="main-menu-two__search-box"> <a href="#"
                                        class="main-menu-two__search searcher-toggler-box icon-search"></a> </div>
                                <div class="main-menu-two__cart-box"> <a href="cart.html" class="main-menu-two__cart">
                                        <span class="far fa-shopping-cart"></span> <span
                                            class="main-menu-two__cart-count">02</span> </a> </div>
                            </div>
                        </div>
                        <!-- <div class="main-menu-two__nav-sidebar-icon">                  <a class="navSidebar-button" href="#">                      <span class="icon-dots-menu-one"></span>                      <span class="icon-dots-menu-two"></span>                      <span class="icon-dots-menu-three"></span>                  </a>              </div> -->
                        <div class="main-menu-two__btn-box"> <a href="javascript:void(0)" class="thm-btn"
                                (click)="openRegister()"> Enquiry
                                <!-- <span>                          <i class="icon-right-arrow"></i>                      </span> -->
                            </a> </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</header>


<div class="register-popup" *ngIf="showRegister">

    <div class="register-overlay" (click)="closeRegister()">
    </div>

    <div class="register-box">

        <span class="close-btn" (click)="closeRegister()">
            <i class="fa fa-times"></i>

        </span>

        <div class="register-header">
            <h3>Enquery Form</h3>
            <p> Fill details below </p>

        </div>

        <form [formGroup]="ContactFrm" (ngSubmit)="feedback()">
            <div class="input-box">
                <input type="text" placeholder="Full Name" formControlName="name">
            </div>
            <div class="input-box">
                <input type="email" placeholder="Email Address" formControlName="email">
            </div>
            <div class="input-box">
                <input type="tel" placeholder="Mobile Number" formControlName="phone_number">
            </div>
            <div class="input-box">
                <input type="text" placeholder="Message" formControlName="message">
            </div>

            <button class="submit-btn" type="submit">
                Submit
            </button>

        </form>

    </div>

</div>